import {useContext, useEffect} from "react";
import {ThemeContext, ThemeContextType} from "../context/Theme.ts";

export const useTheme = (): ThemeContextType => {
    const {themeName, setThemeByName} = useContext(ThemeContext)

    useEffect(
        () => () => {
            setThemeByName('default')
        },
        [setThemeByName]
    )

    return {themeName, setThemeByName}
}
